// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content__1NfDj","postRow":"Content_postRow__2nZ6i"};